import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import { CircularProgress } from '@rmwc/circular-progress';
import '@rmwc/circular-progress/styles';
import { RCTooltip } from '@rmwc/rc-tooltip';
import '@rmwc/rc-tooltip/styles';
import * as calcs from './TableCalcs';
import { useFlexionStore } from '../Stores';
import { getText } from '../Helpers';
import './VorTable.css';

function TubeTable() {
  const Profiles = useFlexionStore((state) => state.Profiles);
  const Sprache = useFlexionStore((state) => state.Sprache);
  const GewDurchbiegung = useFlexionStore((state) => state.GewDurchbiegung);
  const Länge = useFlexionStore((state) => state.Länge);
  const Streckenlast = useFlexionStore((state) => state.Streckenlast);
  const Punktlast = useFlexionStore((state) => state.Punktlast);
  const Slider = useFlexionStore((state) => state.Slider);
  const Radio = useFlexionStore((state) => state.Radio);
  const [text, setText] = useState(getText(Sprache));
  const [DataFetched, setDataFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);

  useEffect(() => {
    setText(getText(Sprache));
  }, [Sprache]);

  const IDs = useMemo(() => {
    const tempIDs = [];
    Profiles.forEach((profile) => {
      if (TubeTable.NAMES.includes(profile.Description)) {
        tempIDs.push(profile.ID);
      }
    });
    return tempIDs;
  }, [Profiles]);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`https://app.rk-rose-krieger.com/api/flexion/manyProfiles?IDs=${IDs}`)
      .then((response) => {
        setData(response.data);
        setLoading(false);
        setDataFetched(true);
      });
  }, [IDs]);

  function getTubeData(name) {
    return data.find((profile) => profile.Description === name);
  }

  function Calculate(name) {
    const tube = getTubeData(name);
    if (tube === undefined) return 0;

    const GewDurchbiegungNum = Number(parseFloat(GewDurchbiegung).toFixed(1));
    if (Number.isNaN(GewDurchbiegungNum) || GewDurchbiegungNum === 0) {
      return 0;
    }

    if (Radio === 'Einseitig') {
      return calcs.Einseitig(tube.Lineargewicht, Länge, tube.E, tube.Iy, Streckenlast, Punktlast);
    }
    return calcs.Zweisitig(
      tube.Lineargewicht,
      Länge,
      tube.E,
      tube.Iy,
      Streckenlast,
      Punktlast,
      Slider
    );
  }

  function createDataCell(name) {
    let result = Number(Calculate(name).toFixed(1));
    if (result >= 1000) {
      result = Number(result.toFixed());
    }
    const GewDurchbiegungNum = Number(parseFloat(GewDurchbiegung).toFixed(1));
    if (result < GewDurchbiegungNum) {
      return (
        <RCTooltip content={name}>
          <td className='greentd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    if (result === GewDurchbiegungNum && GewDurchbiegungNum !== 0) {
      return (
        <RCTooltip content={name}>
          <td className='yellowtd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    if (result > GewDurchbiegungNum) {
      return (
        <RCTooltip content={name}>
          <td className='redtd'>{result.toString().replace('.', ',')}</td>
        </RCTooltip>
      );
    }
    return (
      <RCTooltip content={name}>
        <td>{result.toString().replace('.', ',')}</td>
      </RCTooltip>
    );
  }

  if (loading) {
    return <CircularProgress size={72} />;
  }
  return (
    <>
      <h3>{text.Tables ? text.Tables.Tubes : ' '}</h3>
      <div className='ScrollTable'>
        {/* {!this.state.DataFetched ? <Button outlined onClick={this.fetchIDs} >
        Rohre laden</Button> : ""} */}
        <table>
          <colgroup>
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
            <col className='column' />
          </colgroup>
          <tbody>
            <tr>
              <th />
              <th colSpan='2'>20</th>
              <th colSpan='2'>30</th>
              <th colSpan='2'>40</th>
              <th colSpan='2'>50</th>
              <th colSpan='2'>60</th>
              <th colSpan='2'>80</th>
            </tr>
            <tr>
              <th />
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
              <th>{text.Tables ? text.Tables.Alu : ' '}</th>
              <th>{text.Tables ? text.Tables.Steel : ' '}</th>
            </tr>
            <tr>
              <td>&#9675;</td>
              {DataFetched ? createDataCell('Alu-Rohr Ø 20x3') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr Ø 20x2') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr Ø 30x2') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr Ø 30x2') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr Ø 40x3') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr Ø 40x4') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr Ø 50x3') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr Ø 50x4') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr Ø 60x3') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr Ø 60x5') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('Stahl-Rohr Ø 80x5') : <td />}
            </tr>
            <tr>
              <td>&#9723;</td>
              {DataFetched ? createDataCell('Alu-Rohr 20x1.5') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr 20x2') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr 30x2') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr 30x2') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr 40x4') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr 40x3') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr 50x4') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr 50x3') : <td />}
              {DataFetched ? createDataCell('Alu-Rohr 60x4') : <td />}
              {DataFetched ? createDataCell('Stahl-Rohr 60x4') : <td />}
              <td className='emptytd' />
              {DataFetched ? createDataCell('Stahl-Rohr 80x5') : <td />}
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
TubeTable.NAMES = [
  'Alu-Rohr Ø 20x3',
  'Stahl-Rohr Ø 20x2',
  'Alu-Rohr Ø 30x2',
  'Stahl-Rohr Ø 30x2',
  'Alu-Rohr Ø 40x3',
  'Stahl-Rohr Ø 40x4',
  'Alu-Rohr Ø 50x3',
  'Stahl-Rohr Ø 50x4',
  'Alu-Rohr Ø 60x3',
  'Stahl-Rohr Ø 60x5',
  'Stahl-Rohr Ø 80x5',
  'Alu-Rohr 20x1.5',
  'Stahl-Rohr 20x2',
  'Alu-Rohr 30x2',
  'Stahl-Rohr 30x2',
  'Alu-Rohr 40x4',
  'Stahl-Rohr 40x3',
  'Alu-Rohr 50x4',
  'Stahl-Rohr 50x3',
  'Alu-Rohr 60x4',
  'Stahl-Rohr 60x4',
  'Stahl-Rohr 80x5',
];

export default TubeTable;
